import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../utils/Breadcrumb";
import { useStandard } from "../context/StandardContext";

function ReportLayout({children}) {
  const { standardName } = useStandard();
  const location = useLocation();
  const { stdId } = useParams();
  let pathFile = location.pathname;
  const [labelFile, setLabelFile] = useState("Generate Report");

  let LinkItem = [
    {
      label: "Generate Report",
      link: `/standard/${stdId}/report/genarate-report`,
    },
    {
      label: "Pre-Defined Reports",
      link: `/standard/${stdId}/report/pre-defined-report`,
    },
    {
      label: "Internal Audit Report",
      link: `/standard/${stdId}/report/internal-audit-report`,
    },
  ];

  useEffect(() => {
    if (location.pathname == `/standard/${stdId}/report/genarate-report`) {
      setLabelFile("Generate Report");
    } else if (location.pathname == `/standard/${stdId}/report/pre-defined-report`) {
      setLabelFile("Pre-Defined Reports");
    }else if (location.pathname == `/standard/${stdId}/report/internal-audit-report`) {
      setLabelFile("Internal Audit Report");
    }
  }, [location.pathname]);

  return (
    <div className="w-[100%] h-[calc(100vh-80px)]">
      <div className=" w-[93%] mx-auto">
        <Breadcrumb
          items={[
            {
              name: "Standard",
            },

            {
              name: standardName,
            },
            {
              name: "Report",
            },
            {
              name: labelFile,
            },
          ]}
        />
        </div>
        <div className=" w-[96%] h-full mx-auto">
        <div className=" w-full  h-11 flex  gap-x-9 items-center">
          <div className=" h-11 flex items-center gap-x-1   z-0">
            {LinkItem &&
              LinkItem.map((item, i) => {
                return (
                  <React.Fragment key={i}>
                    {
                      <Link
                        to={item?.link}
                        className={`mx-1  px-1 text-base 2xl:text-lg font-normal text-baseColor-primary ${
                          item?.link == pathFile
                            ? "rounded-t bg-gray-200 border-b-4 border-primary text-gray-600"
                            : "border-b-4 border-transparent text-gray-400"
                        }   `}
                        key={i}
                        onClick={() => {
                          setLabelFile(item?.label);
                          console.log(item?.label);
                        }}
                      >
                        {item?.label || ""}
                      </Link>
                    }
                  </React.Fragment>
                );
              })}
          </div>
        </div>
        <div className="w-[100%] h-[calc(100vh-145px)] p-2 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] rounded-lg overflow-y-auto z-[3]">
        {children}
        </div>
      </div>
    </div>
  );
}

export default ReportLayout;
